'use strict'

import { removeDuplicateItemsInArray } from 'utils/functions'

function numberToDayOfWeek (vm, number) {
  const days = {
    '0': vm.$t('Views.UsagePolicyPage.timeRangeComboBox.daysOfWeekShortened')[0].name,
    '1': vm.$t('Views.UsagePolicyPage.timeRangeComboBox.daysOfWeekShortened')[1].name,
    '2': vm.$t('Views.UsagePolicyPage.timeRangeComboBox.daysOfWeekShortened')[2].name,
    '3': vm.$t('Views.UsagePolicyPage.timeRangeComboBox.daysOfWeekShortened')[3].name,
    '4': vm.$t('Views.UsagePolicyPage.timeRangeComboBox.daysOfWeekShortened')[4].name,
    '5': vm.$t('Views.UsagePolicyPage.timeRangeComboBox.daysOfWeekShortened')[5].name,
    '6': vm.$t('Views.UsagePolicyPage.timeRangeComboBox.daysOfWeekShortened')[6].name
  }

  return days[number]
}

export function getTimePolicyType (intervals) {
  const intervalsOrdened = intervals.sort((a, b) => {
    if (a.dayOfWeek < b.dayOfWeek) return -1
    if (a.dayOfWeek > b.dayOfWeek) return 1
    return 0
  })

  const hasWeekendDays = intervalsOrdened.some(interval => interval.dayOfWeek === 0 || interval.dayOfWeek === 6)
  const intervalsArray = intervalsOrdened.map(interval => {
    const key = `${interval.startTime}-${interval.endTime}`
    return { key, ...interval }
  })

  const dayOfWeekArray = removeDuplicateItemsInArray(intervalsArray.map(interval => interval.key))
  const intervalsGroup = dayOfWeekArray.map(key => {
    const intervals = intervalsArray.filter(i => i.key === key)
    const startTime = intervals[0].startTime
    const endTime = intervals[0].endTime
    const daysOfWeek = intervals.map(i => i.dayOfWeek)

    return {
      key,
      daysOfWeek,
      startTime,
      endTime
    }
  })

  const isWorkingDays = intervalsGroup.every(interval => (
    interval.daysOfWeek.length === 5 &&
    interval.daysOfWeek[0] === 1 &&
    interval.daysOfWeek[interval.daysOfWeek.length - 1] === 5
  ))

  if (isWorkingDays && !hasWeekendDays) {
    return 'workingDays'
  }

  return 'customDays'
}

export function renderLabels (vm, intervals, timePolicyType) {
  const intervalsArray = intervals
    .sort((a, b) => {
      if (a.dayOfWeek < b.dayOfWeek) return -1
      if (a.dayOfWeek > b.dayOfWeek) return 1
      return 0
    })
    .map(interval => {
      const key = `${interval.startTime}-${interval.endTime}`
      return {
        key,
        ...interval
      }
    })

  const dayOfWeekArray = intervalsArray.map(interval => interval.key)
  const intervalsGroup = removeDuplicateItemsInArray(dayOfWeekArray).map(key => {
    const intervals = intervalsArray.filter(i => i.key === key)
    const startTime = intervals[0].startTime
    const endTime = intervals[0].endTime
    const daysOfWeek = intervals.map(i => {
      return {
        text: numberToDayOfWeek(vm, i.dayOfWeek),
        number: i.dayOfWeek
      }
    })

    return {
      key,
      daysOfWeek,
      startTime,
      endTime
    }
  })

  const from = vm.$t(`Views.UsagePolicyPage.timeRangeComboBox.policyCreatedFrom`)
  const to = vm.$t(`Views.UsagePolicyPage.timeRangeComboBox.policyCreatedTo`)
  let labels = []

  if (timePolicyType === 'customDays') {
    labels = intervalsGroup.map(interval => {
      const daysTextConcat = interval.daysOfWeek.reduce((acc, item, index) => {
        const comma = index < interval.daysOfWeek.length - 1 ? ', ' : ' '
        acc += `${item.text}${comma}`
        return acc
      }, '')

      const daysNumberConcat = interval.daysOfWeek.reduce((acc, item) => {
        acc += `${item.number}`
        return acc
      }, '')

      const key = interval.key
      let text = `${daysTextConcat}${from} ${interval.startTime} ${to} ${interval.endTime}`

      if (daysNumberConcat === '0123456') {
        const daysOfWeekLastItem = interval.daysOfWeek.length - 1
        const startDay = interval.daysOfWeek[0].text
        const endDay = interval.daysOfWeek[daysOfWeekLastItem].text
        text = `${startDay} > ${endDay} ${from} ${interval.startTime} ${to} ${interval.endTime}`
        return { key, text }
      }

      return { key, text }
    })
  }

  if (timePolicyType === 'workingDays') {
    labels = intervalsGroup.map(interval => {
      const key = interval.key
      const daysOfWeekLastItem = interval.daysOfWeek.length - 1
      const startDay = interval.daysOfWeek[0].text
      const endDay = startDay !== interval.daysOfWeek[daysOfWeekLastItem].text
        ? `> ${interval.daysOfWeek[daysOfWeekLastItem].text}`
        : ''
      const text = `${startDay} ${endDay} ${from} ${interval.startTime} ${to} ${interval.endTime}`
      return { key, text }
    })
  }

  return labels
}
